<template>
  <v-container
    fluid
    style="
      height:100vh;
      background-color:rgba(20,20,20,0.9);
    "
  >
    <v-container>
      <v-row align="center">
        <v-col class="py-0">
          <v-img
            src="img\stretchlimoberlinDE-logo.png"
            width="20vh"
            style="cursor:pointer;"
            @click="goToWebpage();"
          />
        </v-col>
        <v-col align="right" v-if="values.schritt > 1" class="py-0">
          <v-dialog
            v-model="dialog_reset"
            width="500"
            overlay-opacity="0.8"
            scrollable
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-skip-backward</v-icon>
              </v-btn>
            </template>

            <v-card dark class="back">
              <v-card-title>
                Angaben zurücksetzen
              </v-card-title>

              <v-card-text>
                Möchtest Du alle Angaben zurücksetzen?
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                  text
                  @click="dialog_reset = false"
                >
                  Schließen
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="error"
                  @click="reset();"
                >
                  Zurücksetzen
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
    <v-row v-if="!data.fahrzeugarten">
      <v-col align="center">
        <br /><br /><br />
        <b>Lade Daten!</b>
        <br />
        ...
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-slide-y-transition>
          <BuchungFormFahrtdetails
            v-if="values.schritt === 1"
            :prop_value="values.fahrtdetails"
            :values="values"
            @change="
              values.fahrtdetails = $event;
              values.schritt += 1;
            "
          />
        </v-slide-y-transition>
      </v-col>
      <v-col>
        <v-slide-y-transition>
          <BuchungSelect
            v-if="values.schritt === 2"
            query="fzga"
            :values="values"
            :allowMultiple="false"
            :texte="{
              titel: 'Fahrzeugart',
              frage: 'Welche Farzeugart spricht dich am meisten an?',
            }"
            :items="data.fahrzeugarten"
            :prop_value="values.fahrzeugart"
            @change="
              values.fahrzeugart = $event;
              values.schritt += 1;
            "
            :back="true"
            @back="
              values.schritt -= 1;
            "
          />
        </v-slide-y-transition>
      </v-col>
      <v-col>
        <v-slide-y-transition>
          <BuchungSelect
            v-if="values.schritt === 3"
            query="fzg"
            :values="values"
            :allowMultiple="false"
            :texte="{
              titel: 'Fahrzeuge',
              frage: 'Wähle ein Fahrzeug',
            }"
            :items="data.fahrzeuge.filter((o) => values.fahrzeugart.includes(o.fahrzeugart))"
            :prop_value="values.fahrzeug"
            @change="
              values.fahrzeug = $event;
              values.schritt += 1;
            "
            :back="true"
            @back="
              values.schritt -= 1;
            "
          />
        </v-slide-y-transition>
      </v-col>
      <v-col>
        <v-slide-y-transition>
          <BuchungSelect
            v-if="values.schritt === 4"
            query="pkt"
            :values="values"
            :allowMultiple="true"
            :allowNone="true"
            :texte="{
              titel: 'Pakete',
              frage: `Darf es etwas mehr sein?
              Unsere exklusiven Pakete für ein unvergessliches Erlebnis.`,
            }"
            :items="data.pakete"
            :prop_value="values.pakete"
            @change="
              values.pakete = $event;
              values.schritt += 1;
            "
            :back="true"
            @back="
              values.schritt -= 1;
            "
          />
        </v-slide-y-transition>
      </v-col>
      <v-col>
        <v-slide-y-transition>
          <BuchungFormRechnungsadresse
            v-if="values.schritt === 5"
            :prop_value="values.rechnungsadresse"
            :prop_gesamtuebersicht="values.gesamtuebersicht"
            :values="values"
            @change="
              values.rechnungsadresse = $event;
            "
            @end="
              values.rechnungsadresse = $event;
              finish = false;
              values.schritt += 1;
            "
            @back="
              values.schritt -= 1;
            "
          />
        </v-slide-y-transition>
      </v-col>
      <v-col>
        <v-slide-y-transition>
          <v-container
            v-if="values.schritt > values.anzahlSchritte"
            style="position:absolute;left:50%;transform:translateX(-50%);"
            class="d-flex flex-column justify-center align-center"
          >
          <v-alert
            border="top"
            color="grey darken-4"
            class="pa-8 mt-8"
          >
            <div v-if="!finish"
              align="center"
            >
              <v-btn
                :loading="true"
                class="ma-8"
              >
                asd
              </v-btn>
              <br />
              sende Daten...
            </div>
            <div v-else>
              <div align="center" class="ma-4">
                <img
                  v-if="$vuetify.breakpoint.xsOnly"
                  src="@/assets/undraw_online_party_re_7t6g.svg"
                  width="100%"
                />
                <img v-else src="img\undraw_online_party_re_7t6g.svg" width="50%" />
              </div>
              <h2 class="mb-6">Vielen Dank!</h2>
              <p class="pa-2">
                Wir haben deine Anfrage erhalten und melden uns mit
                einem unverbindlichen Angebot so bald wie möglich per E-Mail.
                <br />
                <br />
                Zur Bestätigung des Eingangs der Anfragedaten wurde
                dir ebenfalls eine E-Mail an
                <b>{{ values.rechnungsadresse.mail }}</b> gesendet.
              </p>
              <div align="center">
                <!-- <v-btn
                  text
                  @click="
                    values.schritt -= 1;
                  "
                >
                  Zurück
                </v-btn> -->
                <!-- <v-btn
                  text
                  color="primary"
                  @click="reset();"
                >
                  Angaben zurücksetzen
                </v-btn> -->
                <!--<a href="https://stretchlimoberlin.de" style="text-decoration:none;"><v-btn
                  text
                  color="primary"
                >
                  Zur Website
                </v-btn></a> -->
              </div>
            </div>
          </v-alert>
          </v-container>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BuchungFormFahrtdetails from '@/components/Buchung/BuchungFormFahrtdetails.vue';
import BuchungSelect from '@/components/Buchung/BuchungSelect.vue';
import BuchungFormRechnungsadresse from '@/components/Buchung/BuchungFormRechnungsadresse.vue';

export default {
  name: 'Buchung',
  components: {
    BuchungFormFahrtdetails,
    BuchungSelect,
    BuchungFormRechnungsadresse,
  },
  data: () => ({
    dialog_reset: false,
    values: {},
    data: {},
    finish: false,
  }),
  computed: {
    fahrzeugpreis() {
      const preis = {
        summe: 0,
        wertErsteStunde: 0,
        wertJeStunde: 0,
        anzahlStunden: 0,
        fahrzeug: '',
      };
      let anzahlStunden = 0;
      let von = `${this.values.fahrtdetails.datumStart} ${this.values.fahrtdetails.uhrzeitStart}`;
      const bis = `${this.values.fahrtdetails.datumEnde} ${this.values.fahrtdetails.uhrzeitEnde}`;
      let preise;
      let istErsteStunde = 0;
      while (von < bis) {
        von = new Date(von.replace(/ /g, 'T'));
        if (this.data.fahrzeuge) {
          if ([0, 5, 6].includes(von.getDay())) {
            if (this.data.fahrzeuge.filter((o) => o.id === this.values.fahrzeug[0])[0].infos[9].includes('+')) {
              preise = this.data.fahrzeuge.filter((o) => o.id === this.values.fahrzeug[0])[0].infos[9].split('+');
            } else {
              preise = ['0', '0'];
            }
            preis.summe += parseFloat(preise[istErsteStunde], 10);
          } else {
            if (this.data.fahrzeuge.filter((o) => o.id === this.values.fahrzeug[0])[0].infos[8].includes('+')) {
              preise = this.data.fahrzeuge.filter((o) => o.id === this.values.fahrzeug[0])[0].infos[8].split('+');
            } else {
              preise = ['0', '0'];
            }
            preis.summe += parseFloat(preise[istErsteStunde], 10);
          }
          preis.fahrzeug = this.data.fahrzeuge
            .filter((o) => o.id === this.values.fahrzeug[0])[0].name;
        }
        von.setHours(von.getHours() + 1);
        von = `${von.getFullYear()}-${String(von.getMonth() + 1).padStart(2, '0')}-${String(von.getDate()).padStart(2, '0')} ${String(von.getHours()).padStart(2, '0')}:${String(von.getMinutes()).padStart(2, '0')}`;
        if (preise) {
          if (anzahlStunden <= 0) {
            [preis.wertErsteStunde, preis.wertJeStunde] = preise;
            istErsteStunde += 1;
          }
        }
        anzahlStunden += 1;
      }
      preis.anzahlStunden = anzahlStunden;
      return preis;
    },
    paketpreise() {
      const pakete = [];
      this.values.pakete[0].forEach((p) => {
        if (this.data.pakete) {
          if (this.data.pakete.filter((o) => o.id === p).length > 0) {
            pakete.push({
              name: this.data.pakete.filter((o) => o.id === p)[0].name,
              preis: parseFloat(this.data.pakete.filter((o) => o.id === p)[0].preis, 10),
            });
          }
        }
      });
      return pakete;
    },
  },
  watch: {
    values: {
      handler(neu, alt) {
        if (alt.schritt) {
          localStorage.removeItem('finish');
        }
        localStorage.setItem('f000', JSON.stringify(neu));
        if (
          this.values.rechnungsadresse.strasse === ''
          && this.values.fahrtdetails.adresseStart.strasse !== ''
          && this.values.schritt !== 5
        ) {
          this.values.rechnungsadresse.strasse = this.values.fahrtdetails.adresseStart.strasse;
        }
        if (
          this.values.rechnungsadresse.plz === ''
          && this.values.fahrtdetails.adresseStart.plz !== ''
          && this.values.schritt !== 5
        ) {
          this.values.rechnungsadresse.plz = this.values.fahrtdetails.adresseStart.plz;
        }
        if (
          this.values.rechnungsadresse.ort === ''
          && this.values.fahrtdetails.adresseStart.ort !== ''
          && this.values.schritt !== 5
        ) {
          this.values.rechnungsadresse.ort = this.values.fahrtdetails.adresseStart.ort;
        }
        // Wenn alle Angaben gemacht wurden, sende die Daten an den Server:
        if (this.values.schritt > this.values.anzahlSchritte) {
          if (!localStorage.getItem('finish')) {
            this.trySendData();
          } else {
            this.finish = true;
          }
        }
        if (neu.schritt === 5) {
          this.getGesamtuebersicht();
        }
      },
      deep: true,
    },
  },
  methods: {
    getGesamtuebersicht() {
      let gesamtsumme = this.fahrzeugpreis.summe;
      let abfahrtsadresse = '';
      if (!this.values.fahrtdetails.adresseUnbekannt) {
        abfahrtsadresse = `
          <b>${this.values.fahrtdetails.adresseStart.strasse}</b><br>
          <b>${this.values.fahrtdetails.adresseStart.plz} ${this.values.fahrtdetails.adresseStart.ort}</b><br>
        `;
      }
      const abfahrtsdatum = new Date(this.values.fahrtdetails.datumStart).toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      let ankunftsadresse = '';
      if (!this.values.fahrtdetails.adresseUnbekannt) {
        ankunftsadresse = `
          <b>${this.values.fahrtdetails.adresseEnde.strasse}</b><br>
          <b>${this.values.fahrtdetails.adresseEnde.plz} ${this.values.fahrtdetails.adresseEnde.ort}</b><br>
        `;
      }
      const ankunftsdatum = new Date(this.values.fahrtdetails.datumEnde).toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      let stringStunden = 'Stunden';
      if (this.fahrzeugpreis.anzahlStunden === 1) {
        stringStunden = 'Stunde';
      }
      let preisFahrzeugUndChauffeur = '-';
      let gesamtwertSuffix = '';
      // console.log(this.fahrzeugpreis.summe);
      if (this.fahrzeugpreis.summe > 0) {
        preisFahrzeugUndChauffeur = this.fahrzeugpreis.summe.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
      } else {
        preisFahrzeugUndChauffeur = 'individuell';
        gesamtwertSuffix = `
          <br/><span style="font-size:80%;">
            zzgl. Fahrzeug und Chauffeur<br/>für ${this.fahrzeugpreis.anzahlStunden} ${stringStunden}
          </span>
        `;
      }
      let html = `
        <p style="padding:0px 5px 0px 5px;">
          <u>Fahrzeug:</u><br><b>${this.fahrzeugpreis.fahrzeug}</b><br>
          Fahrgäste: <b>${this.values.fahrtdetails.fahrtgaeste}</b>
          <br><br>
          <u>Abfahrt:</u><br>
          ${abfahrtsadresse}
          <b>${abfahrtsdatum}</b>
          <b>${this.values.fahrtdetails.uhrzeitStart} Uhr</b><br>
          <br>
          <u>Ankunft:</u><br>
          ${ankunftsadresse}
          <b>${ankunftsdatum}</b>
          <b>${this.values.fahrtdetails.uhrzeitEnde} Uhr</b><br>
          <br>
          <u>Vorläufiges Angebot:</u>
        </p>
        <table cellpadding="5px">
        <tr><td style="padding:5px;">
          Fahrzeug und Chauffeur<br>für ${this.fahrzeugpreis.anzahlStunden} ${stringStunden}:
        </td><td style="font-weight:bold;padding:5px;text-align:right;">
          ${preisFahrzeugUndChauffeur}
        </td></tr>
      `;
      this.paketpreise.forEach((p) => {
        html += `
          <tr><td style="padding:5px;">
            ${p.name}:
          </td><td style="font-weight:bold;padding:5px;text-align:right;">
            ${p.preis.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
          </td></tr>
        `;
        gesamtsumme += p.preis;
      });
      html += `
        <tr valign="top"><td style="padding:5px;">
          <br>
          <div style="border-top:solid #ffffff 1px;height:8px;"></div>
          Geschätzter Gesamtwert*:
        </td><td style="font-weight:bold;padding:5px;">
          <br>
          <div style="border-top:solid #ffffff 1px;height:8px;"></div>
          ${gesamtsumme.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
          ${gesamtwertSuffix}
        </td></tr></table>
        <p style="font-size:80%;">
          * Bitte beachten Sie, dass es sich hierbei nur um ein vorläufiges Angebot, anhand der
          von Ihnen angegebenen Daten, handelt.<br>Irrtümer und Änderungen vorbehalten.
        </p>
      `;
      this.values.gesamtuebersicht = html;
    },
    reset() {
      const date = new Date();
      date.setDate(date.getDate() + 1);
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      this.values = {
        version: '1',
        schritt: 1,
        anzahlSchritte: 5,
        fahrtdetails: {
          fahrtgaeste: 1,
          fahrtgaesteU18: 0,
          datumStart: `${yyyy}-${mm}-${dd}`,
          uhrzeitStart: '08:00',
          adresseStart: {
            strasse: '',
            plz: '',
            ort: '',
          },
          adressenUnbekannt: false,
          datumEnde: '',
          uhrzeitEnde: '08:00',
          adresseEnde: {
            strasse: '',
            plz: '',
            ort: '',
          },
        },
        rechnungsadresse: {
          firma: '',
          name: '',
          mail: '',
          telefon: '',
          strasse: '',
          plz: '',
          ort: '',
          nachricht: '',
          newsletter: false,
          agbUndDatenschutz: false,
          abfrageWoherKennstDuUns: '',
          abfrageWoherKennstDuUnsSonstiges: '',
        },
        fahrzeugart: [],
        fahrzeug: [],
        pakete: [],
        gesamtuebersicht: '',
      };
      localStorage.setItem('f000', JSON.stringify(this.values));
      localStorage.removeItem('finish');
      this.dialog_reset = false;
    },
    async tryGetData() {
      await fetch('https://www.stretchlimoberlin.de/api/', {
        method: 'post',
      })
        .then((response) => response.json())
        .then((data) => {
          this.data = data;
          this.$store.commit('setFormRechnungsadresseUseNachricht', data.settings.formRechnungsadresseUseNachricht);
          let gesetzt = false;
          if (
            this.$router.history.current.query.fzg
          ) {
            gesetzt = true;
            const idFahrzeug = parseInt(this.$router.history.current.query.fzg, 10);
            if (
              this.data.fahrzeuge
                .filter((o) => o.id === idFahrzeug)
                .length > 0
            ) {
              this.values.fahrzeug = [
                this.data.fahrzeuge
                  .filter((o) => o.id === idFahrzeug)[0].id,
              ];
              this.values.fahrzeugart = [
                this.data.fahrzeuge
                  .filter((o) => o.id === idFahrzeug)[0].fahrzeugart,
              ];
            }
          }
          if (
            this.$router.history.current.query.pkt
          ) {
            gesetzt = true;
            let idPaket = this.$router.history.current.query.pkt;
            idPaket = idPaket.split('-');
            idPaket.forEach((p) => {
              if (
                this.data.pakete
                  .filter((o) => o.id === parseInt(p, 10))
                  .length > 0
              ) {
                if (!this.values.pakete[0]) {
                  this.values.pakete[0] = [parseInt(p, 10)];
                } else if (!this.values.pakete[0].includes(parseInt(p, 10))) {
                  this.values.pakete[0].push(parseInt(p, 10));
                }
              }
            });
          }
          if (gesetzt) {
            this.$router.push({ path: '/' });
          }
        });
    },
    async trySendData() {
      const data = new FormData();
      data.append('values', JSON.stringify(this.values));
      await fetch('https://www.stretchlimoberlin.de/api/send/', {
        method: 'post',
        body: data,
      })
        .then((response) => response.json())
        .then(() => {
          this.finish = true;
          localStorage.setItem('finish', '1');
        });
    },
    goToWebpage() {
      window.location.href='https://www.stretchlimoberlin.de/';
    },
  },
  created() {
    this.tryGetData();
    if (localStorage.getItem('f000')) {
      this.values = JSON.parse(localStorage.getItem('f000'));
      if (!this.values.version || this.values.version !== '1') {
        this.reset();
      }
    } else {
      this.reset();
    }
  },
};
</script>
<style>
  body {
    background-color: var(--v-back-base) !important;
  }
</style>
